// extracted by mini-css-extract-plugin
export default {"fwrAuthHeader":"NewLogin_fwrAuthHeader__D0AJ2","fwrLogo":"NewLogin_fwrLogo__6fBLe","fwrkLogin":"NewLogin_fwrkLogin__FP0Me"};